// extracted by mini-css-extract-plugin
export default {"aboutPage":"AboutPage_aboutPage__Wo9Gl","aboutTitle":"AboutPage_aboutTitle__ZGtca","aboutContent":"AboutPage_aboutContent__JXMLG"};